import React from 'react';
import { Container, Header, Plate, Text, Title } from 'features/shared/ui/Page';
import { Space } from '@gr-monorepo/common/ui';
import reports from './images/reports-min.png';
import reports2 from './images/reports2-min.png';
import studentsCount from './images/students_count-min.png';
import studentsCount2 from './images/students_count_2-min.png';
import surveys from './images/surveys-min.png';
import surveys2 from './images/surveys2-min.png';
import gratitude from './images/gratitude-min.png';
import indicators from './images/indicators-min.png';
import Gallery from './Gallery';
import useUserData from 'hooks/useUserData';
import useGratitudeCheck from 'hooks/useGratitudeCheck';
import { Link } from 'react-router-dom';
import { useClickStreamContext } from 'features/shared/ClickStream';

const Updates = () => {
  const userData = useUserData();
  const { years } = useGratitudeCheck();
  const context = useClickStreamContext();

  return (
    <Container>
      <Header>
        Обновления в Кабинете {userData?.userType === 'region' ? 'региона' : 'муниципалитета'}
        <br />
        Новое за 2022–2023 год
      </Header>
      <Space axis="vertical" size={42} />
      <Plate>
        <Title>Форма обратной связи</Title>
        <Space axis="vertical" size={8} />
        <Text>
          Дает возможность быстро задавать вопросы и делиться предложениями по Кабинету региона и муниципалитета. Наша
          команда оперативно изучит ваше обращение и поможет.
        </Text>
        <Space axis="vertical" size={32} />
        <Gallery images={[reports, reports2]} eventLogId="reports"></Gallery>
      </Plate>
      <Space axis="vertical" size={32} />
      {!userData?.isLargeCity && ['municipality', 'citydistrict'].includes(userData?.userType || '') ? (
        <>
          <Plate>
            <Title>Изменение количества учеников</Title>
            <Space axis="vertical" size={8} />
            <Text>
              Позволяет в разделе «Школы» — «Список активных школ» указывать общее количество учеников во всех школах
              муниципалитета и каждом учреждении отдельно. Это делает статистику более информативной и точной.
            </Text>
            <Space axis="vertical" size={32} />
            <Gallery images={[studentsCount, studentsCount2]} eventLogId="studentsCount"></Gallery>
          </Plate>
          <Space axis="vertical" size={32} />
        </>
      ) : null}

      <Plate>
        <Title>Раздел «Пройти опрос»</Title>
        <Space axis="vertical" size={8} />
        <Text>
          Позволяет проходить опросы о возможностях Кабинета региона и муниципалитета. Наша команда изучит ответы и
          внесет необходимые изменения в сервис. Сейчас вы можете пройти{' '}
          <Link
            to={'/surveys'}
            style={{ textDecoration: 'underline', cursor: 'pointer', color: 'rgba(9,21,38,0.85)' }}
            onClick={() => {
              context.logPageEvent({
                eventInfo: 'Обновления кабмуна: клик по ссылке опроса',
                eventType: 'cabmun_updates_click_surveys_link',
              });
              window.scroll(0, 0);
            }}
          >
            опрос об Excel-отчетах
          </Link>{' '}
          из разделов «Школы» и «Олимпиады».
        </Text>
        <Space axis="vertical" size={32} />
        <Gallery images={[surveys, surveys2]} eventLogId="surveys"></Gallery>
      </Plate>
      <Space axis="vertical" size={32} />
      {years.length > 0 && (
        <>
          <Plate>
            <Title>Раздел «Портфолио»</Title>
            <Space axis="vertical" size={8} />
            <Text>Позволяет смотреть и скачивать благодарственные документы от платформы Учи.ру.</Text>
            <Space axis="vertical" size={32} />
            <Gallery images={[gratitude]} eventLogId="gratitude"></Gallery>
          </Plate>
          <Space axis="vertical" size={32} />
        </>
      )}
      <Plate>
        <Title>Планы на 2023–2024 год</Title>
        <Space axis="vertical" size={8} />
        <Text>
          Сделаем статистику в разделах «Школы» и «Олимпиады» еще удобнее и нагляднее.
          <br />
          Улучшим Excel-отчеты из разделов «Школы» и «Олимпиады» в соответствии с результатами опроса.
          <br />
          Добавим статистику по количеству учителей, записавшихся и прошедших курсы повышения квалификации, а также
          полученным удостоверениям.
        </Text>
      </Plate>
    </Container>
  );
};

export default Updates;
